import wishlistMessages from './WishlistMessageConstants';
import wishlistStatusCodes from './wishlistStatusCodes';

export function getWishlistAPIResponseMessage(
  wishlistResponse,
  requestedBy,
  requestedDeviceType = 'desktop'
) {
  const {
    ITEM_MOVED_MESSAGE = '',
    ITEM_EXIST_MESSAGE = '',
    FAILED_TO_MOVE_MESSAGE_FOR_OUTOFSTOCK_ITEM = '',
    FAILED_TO_MOVE_MESSAGE_FOR_INSTOCK_ITEM = '',
    SERVICE_UNAVAILABLE_MESSAGE = '',
    MOBILE_ITEM_EXIST_MESSAGE = ''
  } = wishlistMessages;

  const {
    ITEM_ADDED_TO_WISHLIST = '',
    API_FAILED_TO_ADD_ITEM_TO_WISHLIST = '',
    API_SERVICE_UNAVAILABLE = '',
    ITEM_ALREADY_EXIST_IN_WISHLIST = '',
    ITEM_DELISTED_FROM_SITE = ''
  } = wishlistStatusCodes;

  const { statusCode = '' } = wishlistResponse;

  const moveToWishListFailedMsg =
    requestedBy === 'viaProductCardWithRemoveOutOfStockOption'
      ? FAILED_TO_MOVE_MESSAGE_FOR_OUTOFSTOCK_ITEM
      : FAILED_TO_MOVE_MESSAGE_FOR_INSTOCK_ITEM;

  switch (statusCode) {
    case ITEM_ADDED_TO_WISHLIST:
      return ITEM_MOVED_MESSAGE;
    case API_SERVICE_UNAVAILABLE:
      return SERVICE_UNAVAILABLE_MESSAGE;
    case ITEM_ALREADY_EXIST_IN_WISHLIST:
      return requestedDeviceType !== 'msite' ? ITEM_EXIST_MESSAGE : MOBILE_ITEM_EXIST_MESSAGE;
    case API_FAILED_TO_ADD_ITEM_TO_WISHLIST:
    case ITEM_DELISTED_FROM_SITE:
      return moveToWishListFailedMsg;
    default:
      return SERVICE_UNAVAILABLE_MESSAGE;
  }
}
